import { render, staticRenderFns } from "./MediaPicker.vue?vue&type=template&id=c3e2158a&"
import script from "./MediaPicker.vue?vue&type=script&lang=js&"
export * from "./MediaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MediaPicker.vue"
export default component.exports